import Vue from "vue";

export const SET_PROJECT_ID = 'setProjectId';
export const SET_ACCOUNT_NAME = 'setAccountName';
export const SET_PATH = 'setPath';
export const SET_NAVBAR = 'setNavbar';
export const SET_NAVBAR_IS_FETCH = 'setSecondaryNavbarIsFetch';
export const SET_NAVBAR_MANU_COLOR = 'setNavbarMenuColor';
export const SET_NAVBAR_LOGO_URL = 'setNavbarLogoUrl';
export const SET_NAVBAR_DARK_MENU = 'setNavbarDarkMenu';
export const SET_NAVBAR_IS_GUEST = 'setNavbarIsGuest';
export const SET_NAVBAR_USER = 'setNavbarUser';
export const SET_NAVBAR_IS_MAIN_DOMAIN = 'setNavbarIsMainDomain';
export const SET_NAVBAR_IS_SUPER_ADMIN = 'setNavbarIsSuperAdmin';
export const SET_NAVBAR_WINDOW_WIDTH = 'setNavbarWindowWidth';
export const SET_NAVBAR_FREE_TRIAL_NOT_EXPIRED = 'setNavbarFreeTrialNotExpired';

export default {
  [SET_PROJECT_ID](state, projectId = null) {
    state.navbar.projectId = projectId;
  },
  [SET_PATH](state, path = undefined) {
    state.navbar.path = path;
  },
  [SET_ACCOUNT_NAME](state, accountName = null) {
    state.navbar.accountName = accountName;
  },
  [SET_NAVBAR](state, data) {
    for (let key in data) {
      Vue.set(state.navbar, key, data[key]);
    }
  },
  [SET_NAVBAR_IS_FETCH](state, isFetch = false) {
    state.navbar.isFetch = isFetch;
  },
  [SET_NAVBAR_MANU_COLOR](state, menuColor = '') {
    state.navbar.menuColor = menuColor;
  },
  [SET_NAVBAR_LOGO_URL](state, logoUrl = '') {
    state.navbar.logoUrl = logoUrl;
  },
  [SET_NAVBAR_DARK_MENU](state, hex = '') {
    let r = parseInt(hex.substring(1, 3), 16);
    let g = parseInt(hex.substring(3, 5), 16);
    let b = parseInt(hex.substring(5, 7), 16);
    let average = (r + g + b) / 3;

    state.navbar.darkMenu = average < 128;
  },
  [SET_NAVBAR_IS_GUEST](state, isGuest = true) {
    state.navbar.isGuest = isGuest;
  },
  [SET_NAVBAR_USER](state, user = {}) {
    for (let key in user) {
      let value = user[key];
      if (['role'].includes(key) && !value) {
        continue;
      }
      state.navbar.user[key] = value;
    }
  },
  [SET_NAVBAR_IS_MAIN_DOMAIN](state, isMainDomain = true) {
    state.navbar.isMainDomain = isMainDomain;
  },
  [SET_NAVBAR_IS_SUPER_ADMIN](state, isSuperAdmin = false) {
    state.navbar.isSuperAdmin = isSuperAdmin;
  },
  [SET_NAVBAR_WINDOW_WIDTH](state, windowWidth = 0) {
    state.navbar.windowWidth = windowWidth;
  },
  [SET_NAVBAR_FREE_TRIAL_NOT_EXPIRED](state, freeTrialNotExpired) {
    state.navbar.freeTrialNotExpired = freeTrialNotExpired === '1' ? true : (freeTrialNotExpired === '0' ? false : undefined);
  }
}
